import React from 'react'
import { useStyles } from './style'
import { Button, Checkbox, useMediaQuery, useTheme } from '@material-ui/core'
import SkeletonCircleText from 'components/common/SkeletonCircleText'
import DefaultOrderItem from './DefaultOrderItem'
import DeliveryOrderItem from './DeliveryOrderItem'
import OrderListItemMobile from './OrderListItemMobile'
import OrderListDeliveryItemMobile from './OrderListDeliveryItemMobile'

const OrderList = props => {
  const styles = useStyles()
  const [expandedList, setExpandedList] = React.useState([])

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  const userData = JSON.parse(localStorage.getItem('userdata'))

  const toggleExpand = (index, isExpanded) => {
    if (isExpanded) {
      setExpandedList(prev => prev.filter(p => p !== index))
    } else {
      setExpandedList(prev => [...prev, index])
    }
  }

  if (props.isLoading) {
    return ['', '', '', '', ''].map((item, index) => (
      <SkeletonCircleText
        key={index}
        style={{ width: '100%', height: '200px', borderRadius: '8px' }}
      />
    ))
  }

  if (props.isError) {
    return <div className={styles.boxContainer}>Something went wrong</div>
  }

  if (props.listOrder.length === 0) {
    return <div className={styles.boxContainer}>No data found</div>
  }

  const selectedLength = props.selectedOrder.length

  return (
    <div className={styles.list}>
      {props.status === 'WAITING APPROVAL HOD' && userData?.role === 'hod' && (
        <div style={{ display: 'flex', padding: isMobile ? '0' : '0 30px', gap: 24 }}>
          <div
            style={{ display: 'flex', alignItems: 'center', gap: 2, cursor: 'pointer' }}
            onClick={() => props.setIsSelectAll(!props.isSelectAll)}
          >
            <Checkbox
              className={styles.checkboxCustom}
              style={{ padding: 0, marginRight: 8 }}
              checked={props.isSelectAll}
              onChange={() => props.setIsSelectAll(!props.isSelectAll)}
            />
            <p style={{ fontSize: 14, fontWeight: 600, color: 'black', margin: 0 }}>Select All</p>
          </div>
          {selectedLength > 0 && (
            <div style={{ display: 'flex', gap: 10 }}>
              <Button
                variant='outlined'
                onClick={() => props.onApproval(true)}
                style={{
                  backgroundColor: 'white',
                  fontSize: 14,
                  fontWeight: 600,
                  borderRadius: 8,
                  textTransform: 'unset'
                }}
              >
                Approve ({selectedLength})
              </Button>
              <Button
                variant='outlined'
                onClick={() => props.onApproval(false)}
                style={{
                  backgroundColor: 'white',
                  fontSize: 14,
                  fontWeight: 600,
                  borderRadius: 8,
                  textTransform: 'unset'
                }}
              >
                Reject ({selectedLength})
              </Button>
            </div>
          )}
        </div>
      )}
      {props.listOrder.map((order, idx) => {
        if (isMobile) {
          if (['ON DELIVERY', 'COMPLETED'].includes(props.status)) {
            return (
              <OrderListDeliveryItemMobile key={idx} data={order} showDetail={props.showDetail} />
            )
          }

          return (
            <OrderListItemMobile
              key={idx}
              data={order}
              setSelectedOrder={props.setSelectedOrder}
              selectedOrder={props.selectedOrder}
              showDetail={props.showDetail}
            />
          )
        }

        if (['ON DELIVERY', 'COMPLETED'].includes(props.status)) {
          return (
            <DeliveryOrderItem
              key={order.id}
              order={order}
              idx={idx}
              status={props.status}
              userData={userData}
              expandedList={expandedList}
              setSelectedOrder={props.setSelectedOrder}
              selectedOrder={props.selectedOrder}
              showDetail={props.showDetail}
              toggleExpand={toggleExpand}
            />
          )
        }

        return (
          <DefaultOrderItem
            key={order.order.id}
            order={order}
            idx={idx}
            status={props.status}
            userData={userData}
            expandedList={expandedList}
            setSelectedOrder={props.setSelectedOrder}
            selectedOrder={props.selectedOrder}
            showDetail={props.showDetail}
            toggleExpand={toggleExpand}
          />
        )
      })}
    </div>
  )
}

export default OrderList
